export default {"src":"/_next/static/media/dwnld-w.e5128703.svg","height":25,"width":23,"blurWidth":0,"blurHeight":0};